import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { APP_CONFIG, Language } from '@src/core';
import { StorageKeys } from '@src/constants/storage';
import { StorageService } from '@src/app/modules/auth';

@Component({
  selector: 'app-language-switcher-mini',
  templateUrl: './language-switcher-mini.component.html',
  styleUrls: ['./language-switcher-mini.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageSwitcherMiniComponent {
  private readonly translateService = inject(TranslateService);
  private readonly storageService = inject(StorageService);

  selectedLanguage = this.translateService.currentLang;
  readonly languageCodes = APP_CONFIG.localizations;

  selectLanguage(code: Language) {
    this.storageService.setItem(StorageKeys.Locale, code);
    this.translateService.use(code);

    // TODO: убрать после исправления ошибки #9372
    if (this.translateService.currentLang !== code) {
      location.reload();
    }
  }
}
